import React from "react";

const Facebook = props => (
  <svg width={24} height={24} viewBox="0 0 24 24" {...props}>
    <path
      fill="#3c5999"
      d="M5 3h14a2 2 0 012 2v14a2 2 0 01-2 2H5a2 2 0 01-2-2V5a2 2 0 012-2m13 2h-2.5A3.5 3.5 0 0012 8.5V11h-2v3h2v7h3v-7h3v-3h-3V9a1 1 0 011-1h2V5z"
    />
  </svg>
);

export default Facebook;
